import React from 'react'

const AboutTarbiyahMb = () => {
  return (
    <div className="abouttarbiyahmb"  data-aos-delay="400" data-aos="fade-up" data-aos-duration="2000">
        <div className="mycontainermb">
            <div className="mysubheading text-center">
                <h4 className='subheading'>About Tarbiyah <br/> Institude</h4>

            </div>

            <div className="paragraphofabout">
                <p>Every Muslim recognizes the importance of learning the Quran, but only a few attempts to learn the Quran with understanding and spend their lives on the basis of the Quran and Islamic teachings. TARBIYAH INSTITUTE is established a clear path for success in this life and the Hereafter by understanding with the aim to spread the Quran and Hadith. TARBIYAH INSTITUTE is well reputed online Islamic Educational Platform where we offer different courses, such as Quranic Arabic, Arabic Grammar, Modern Arabic Language, Skill Development and Parenting Courses for all levels from beginner to advance through the most easy and engaging way by the</p>
            </div>
        </div>
    </div>
  )
}

export default AboutTarbiyahMb